(function () {
    'use strict';

    var API_BASE = 'https://pollingreport.uk/api/v1';
    var PARTY_KEYS = ['con', 'lab', 'lib', 'snp', 'green', 'reform', 'plaid', 'other'];
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    var roots = document.querySelectorAll('[data-ukpr-results-table]');
    if (!roots.length) return;

    roots.forEach(function (root) {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';
        initWidget(root);
    });

    function initWidget(root) {
        var bodyEl = root.querySelector('[data-results-table-body]');
        var metaEl = root.querySelector('[data-results-table-meta]');
        var pageStatusEl = root.querySelector('[data-results-page-status]');
        var prevBtn = root.querySelector('[data-results-page-prev]');
        var nextBtn = root.querySelector('[data-results-page-next]');
        var state = {
            page: 1,
            perPage: 10,
            model: 'uniform',
            meta: null,
            loading: false,
            hasLoaded: false
        };

        function escHtml(str) {
            return String(str || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/\"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }

        function formatDate(str) {
            if (!str) return '-';
            var parts = String(str).split('T')[0].split('-');
            if (parts.length < 3) return str;
            return parseInt(parts[2], 10) + ' ' + MONTHS[parseInt(parts[1], 10) - 1];
        }

        function formatNumber(value) {
            var n = Number(value);
            if (!isFinite(n)) return '—';
            return new Intl.NumberFormat('en-GB').format(n);
        }

        function getSeatProjection(result, key) {
            var party = result && result.parties ? result.parties[key] : null;
            var seats = party && party.seats ? party.seats : null;
            return seats && seats.prediction != null ? seats.prediction : null;
        }

        function renderLead(result) {
            var lead = result && result.lead ? result.lead : {};
            var winner = String(lead.winner || 'other').toLowerCase();
            var points = Number(lead.points || 0);
            return '<span class="ukpr-results-table-chip winner-' + escHtml(winner) + '">' + escHtml(formatNumber(points)) + '</span>';
        }

        function renderRows(items) {
            if (!items.length) {
                bodyEl.innerHTML = '<tr><td class="ukpr-results-table-empty" colspan="10">No results available.</td></tr>';
                return;
            }

            bodyEl.innerHTML = items.map(function (result) {
                var cells = PARTY_KEYS.map(function (key) {
                    return '<td class="ukpr-results-table-party cell-' + escHtml(key) + '"><span>'
                        + escHtml(formatNumber(getSeatProjection(result, key)))
                        + '</span></td>';
                }).join('');

                return [
                    '<tr>',
                    '<td class="ukpr-results-table-date">' + escHtml(formatDate(result.created_at)) + '</td>',
                    cells,
                    '<td class="ukpr-results-table-lead is-numeric">' + renderLead(result) + '</td>',
                    '</tr>'
                ].join('');
            }).join('');
        }

        function updatePagination() {
            var meta = state.meta || {};
            var current = Number(meta.current_page || state.page || 1);
            var last = Number(meta.last_page || 1);
            var total = Number(meta.total || 0);
            if (metaEl) {
                metaEl.textContent = total ? total + ' results' : '';
            }
            pageStatusEl.textContent = 'Page ' + current + ' of ' + last;
            prevBtn.disabled = state.loading || current <= 1;
            nextBtn.disabled = state.loading || current >= last;
        }

        function setLoading() {
            if (!state.hasLoaded) {
                bodyEl.innerHTML = '<tr><td class="ukpr-results-table-empty" colspan="10">Loading latest results...</td></tr>';
            }
            root.classList.add('is-loading');
            updatePagination();
        }

        function setError() {
            root.classList.remove('is-loading');
            if (!state.hasLoaded) {
                bodyEl.innerHTML = '<tr><td class="ukpr-results-table-empty" colspan="10">Result data unavailable.</td></tr>';
            }
            updatePagination();
        }

        function clearLoadingState() {
            root.classList.remove('is-loading');
        }

        function fetchPage() {
            state.loading = true;
            setLoading();

            var url = API_BASE + '/results?paginate=true&per_page=' + encodeURIComponent(state.perPage)
                + '&legacy=false'
                + '&model=' + encodeURIComponent(state.model)
                + '&page=' + encodeURIComponent(state.page);
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.onload = function () {
                state.loading = false;
                if (xhr.status !== 200) {
                    setError();
                    return;
                }
                try {
                    var payload = JSON.parse(xhr.responseText);
                    state.meta = payload.meta || null;
                    renderRows(Array.isArray(payload.data) ? payload.data : []);
                    state.hasLoaded = true;
                    requestAnimationFrame(clearLoadingState);
                    updatePagination();
                } catch (e) {
                    setError();
                }
            };
            xhr.onerror = function () {
                state.loading = false;
                setError();
            };
            xhr.send();
        }

        prevBtn.addEventListener('click', function () {
            if (state.loading || state.page <= 1) return;
            state.page -= 1;
            fetchPage();
        });

        nextBtn.addEventListener('click', function () {
            var last = Number((state.meta && state.meta.last_page) || 1);
            if (state.loading || state.page >= last) return;
            state.page += 1;
            fetchPage();
        });

        document.addEventListener('ukpr:results-history-model-change', function (ev) {
            var nextModel = ev && ev.detail ? ev.detail.model : null;
            if (!nextModel || nextModel === state.model || state.loading) return;
            state.model = nextModel;
            state.page = 1;
            fetchPage();
        });

        updatePagination();
        fetchPage();
    }
})();
